import { render } from "./RegistroMovimientos.vue?vue&type=template&id=88d2a8a4&scoped=true"
import script from "./RegistroMovimientos.vue?vue&type=script&lang=js"
export * from "./RegistroMovimientos.vue?vue&type=script&lang=js"

import "./RegistroMovimientos.vue?vue&type=style&index=0&id=88d2a8a4&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88d2a8a4"]])

export default __exports__